export default __webpack_public_path__ + "static/media/s-5.1d606a72.jpg";